module.exports = __webpack_public_path__ + "static/media/ic-close.36cc3636.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nxbus/ic-close.svg
// module id = 103
// module chunks = 0